module.exports = __webpack_public_path__ + "static/media/Milex Inflatoball Pessary Instructions for Use@3x.f7ada95b.jpg";